module.exports = __webpack_public_path__ + "static/media/4.db5c88b5.webp";